import { SVGProps } from 'react'

const CheckEligibiltyIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_13382_70676"
        {...{ 'mask-type': 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="18"
      >
        <rect x="0.87915" width="18" height="18" fill="#FFF4F4" />
      </mask>
      <g mask="url(#mask0_13382_70676)">
        <path
          d="M2.37915 15V12.9C2.37915 12.4875 2.4854 12.1 2.6979 11.7375C2.9104 11.375 3.20415 11.1 3.57915 10.9125C4.21665 10.5875 4.9354 10.3125 5.7354 10.0875C6.5354 9.8625 7.41665 9.75 8.37915 9.75C8.75415 9.75 9.11978 9.76875 9.47603 9.80625C9.83228 9.84375 10.1792 9.9 10.5167 9.975L9.20415 11.2875C9.06665 11.2625 8.93228 11.25 8.80103 11.25H8.37915C7.49165 11.25 6.69478 11.3562 5.98853 11.5687C5.28228 11.7812 4.70415 12.0125 4.25415 12.2625C4.14165 12.325 4.05103 12.4125 3.98228 12.525C3.91353 12.6375 3.87915 12.7625 3.87915 12.9V13.5H8.56665L10.0667 15H2.37915ZM12.5417 15.3L9.95415 12.7125L11.0042 11.6625L12.5417 13.2L16.3292 9.4125L17.3792 10.4625L12.5417 15.3ZM8.37915 9C7.55415 9 6.8479 8.70625 6.2604 8.11875C5.6729 7.53125 5.37915 6.825 5.37915 6C5.37915 5.175 5.6729 4.46875 6.2604 3.88125C6.8479 3.29375 7.55415 3 8.37915 3C9.20415 3 9.9104 3.29375 10.4979 3.88125C11.0854 4.46875 11.3792 5.175 11.3792 6C11.3792 6.825 11.0854 7.53125 10.4979 8.11875C9.9104 8.70625 9.20415 9 8.37915 9ZM8.37915 7.5C8.79165 7.5 9.14478 7.35312 9.43853 7.05937C9.73228 6.76562 9.87915 6.4125 9.87915 6C9.87915 5.5875 9.73228 5.23438 9.43853 4.94062C9.14478 4.64687 8.79165 4.5 8.37915 4.5C7.96665 4.5 7.61353 4.64687 7.31978 4.94062C7.02603 5.23438 6.87915 5.5875 6.87915 6C6.87915 6.4125 7.02603 6.76562 7.31978 7.05937C7.61353 7.35312 7.96665 7.5 8.37915 7.5Z"
          fill="#C8355A"
        />
      </g>
    </svg>
  )
}
export default CheckEligibiltyIcon
